import { render, staticRenderFns } from "./StatusInfoHome.vue?vue&type=template&id=883148d8&scoped=true&"
import script from "./StatusInfoHome.vue?vue&type=script&lang=js&"
export * from "./StatusInfoHome.vue?vue&type=script&lang=js&"
import style0 from "./StatusInfoHome.vue?vue&type=style&index=0&id=883148d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883148d8",
  null
  
)

export default component.exports